module.exports = __webpack_public_path__ + "09b48566da3564299a3890c70efcf857.svg";